module.exports = __webpack_public_path__ + "img/onboarding/change-settings-10009e50111ff700bdeae29784399d6f.svg";